module.exports = "27a108009dd3f84c99461d3bcfb9bf7b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/bg8.png
// module id = 78
// module chunks = 0